import { useMutation } from '@tanstack/react-query';
import { deleteUserAccount } from 'api/delete-user-account';

export function useDeleteAccount() {
  const mutation = useMutation({
    mutationFn: deleteUserAccount,
    // This is a mock function to simulate the API call
    // (userId?: string) => new Promise((r) => setTimeout(r, 2000)),
  });
  return mutation;
}
